import { SpaceVertical } from '@looker/components';
import { BIIcon, type IconName } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import type { FC } from 'react';

interface ErrorDisplayProps {
  icon?: IconName;
  text?: string;
}

export const ErrorDisplay: FC<ErrorDisplayProps> = ({ icon = 'ConfusedCow', text }) => (
  <SpaceVertical gap="u6" align="center">
    <BIIcon icon={icon} size={128} />
    {text ? (
      <DsTypography align="center" color="secondary">
        {text}
      </DsTypography>
    ) : null}
  </SpaceVertical>
);
